<div class="layout {{ printClasses }}">
    <app-header [ngClass]="{ 'menu-active': showMenu }" (evtMenu)="toggleMenu()"></app-header>
    <app-sidebar [ngClass]="{ 'hide': !showMenu }"></app-sidebar>
    <main>
        <div class="alert alert-danger" *ngIf="errorsSync.length">{{ 'general.errors.ERRORS_SYNC' | translate }}</div>
        <router-outlet></router-outlet>
    </main>
</div>